
export default {
    props: {
        customLocalization: {
            type: String,
            default: ''
        }
    },
    data: function () {
        return {
            loading: true,
            emptyPerson: '',
            emptyPersonFemale: '',
            emptyPersonMale: '',
            lazyLoadItem: '',
            store: null,
            storeState: {state: null},
            loc_name: null,
            maskAccountId: d => d,
            aid: null
        }
    },
    created: function () {
        this.beforeCreateMethod();
        if (!window.MLMSoftUICore)
            window.addEventListener('singletonCreated', () => {
                this.store = window.MLMSoftUICore.instance.getStore();
                this.createdMethod();
            });
        else {
            this.store = window.MLMSoftUICore.instance.getStore();
            this.createdMethod();
        }
    },
    mounted() {
        let fFR;
        let that = this;
        if (!window.MLMSoftUICore)
            window.addEventListener('singletonCreated', () => {
                let store = window.MLMSoftUICore.instance.getStore();
                fFR = store.state.fontFamilyRe;
                if (fFR)
                    setFontFamily(fFR)
            });
        else {
            fFR = this.store.state.fontFamilyRe;
            if (fFR)
                setFontFamily(fFR)
        }

        function setFontFamily(ff) {
            const body_ref = that.$refs.body;
            if (body_ref)
                body_ref.style.fontFamily = ff
        }

    },
    computed: {
        locale() {
            return this.storeState.state ? this.storeState.state.locale : null;
        },
        isLoggedIn() {
            return this.storeState.state ? this.storeState.state.isLoggedIn : null;
        },
        getInfoDefP() {
            return undefined;
        }
    },
    watch: {
        locale(newLocale) {
            if (newLocale)
                // if (this.isLoggedIn)
                //     this.isLoggedIn_(true);
                if (this.$i18n){
                    this.$i18n.locale = newLocale;
                    this.localeChange();
                }
        },
        isLoggedIn(newValue) {
            this.isLoggedIn_(newValue);
        }
    },
    methods: {
        isLoggedIn_(newValue) {
            if (newValue) {
                this.preGetInfo();
            } else {
                this.postGetInfo();
                this.loading = true;
            }
        },
        localeChange() {

        },
        preGetInfo() {
            if (this.getInfoDefP === undefined)
                this.getInfo();
            else
                this.getInfo(...this.getInfoDefP);
        },
        postGetInfo() {

        },
        beforeCreateMethod() {
        },
        createdMethod() {
            this.maskAccountId = window.MLMSoftUICore.formatAccountId;
            this.getAp();
            if (this.loc_name){
                this.store.dispatch('getLocalizationModule', {module: this.loc_name, i18n: this.$i18n, customLocalization: this.customLocalization}).then(() => {
                    this.storeState.state = this.store.state;
                });
            }
            else
                this.storeState.state = this.store.state;
            this.emptyPerson = this.store.state.emptyPerson;
            this.emptyPersonFemale = this.store.state.emptyPersonFemale;
            this.emptyPersonMale = this.store.state.emptyPersonMale;
            this.lazyLoadItem = this.store.state.lazyLoadItem;
        },
        getInfo() {

        },
        getAp() {

        }
    }
}
